import { useFocus } from "source/shared/hooks/useFocus"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { extractMessagesFrom } from "../stores/validations"
import { Designation, ValidationErrorMessage, ValidationErrors } from "../types"
import { designationTotal } from "../utils/designationTotal"
import { BigCurrencyInput } from "./display/BigCurrencyInput"

export function AmountInput({
  designations,
  errors,
}: {
  designations: Designation[]
  errors: ValidationErrors
}) {
  if (designations.length > 1) {
    const errorMessages = errors.totalAmount || []
    return (
      <ReadOnlyTotalDesignationAmount {...{ designations, errorMessages }} />
    )
  } else {
    const designation = designations[0]
    const errorMessages = extractMessagesFrom(
      errors,
      "totalAmount",
      `designation_${designation.fundId}_amount`,
    )

    return <FirstDesignationAmountInput {...{ designation, errorMessages }} />
  }
}

type FirstDesignationAmountInputProps = {
  designation: Designation
  errorMessages: ValidationErrorMessage[]
}
function FirstDesignationAmountInput(props: FirstDesignationAmountInputProps) {
  const { dispatch, config } = useDonationFormContext()
  const [focusRef] = useFocus(true)
  const {
    designation: { fundId, amount },
    errorMessages,
  } = props

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "UPDATE_DESIGNATION_AMOUNT",
      fundId,
      amount: e.target.value,
    })
  }

  const onBlur = () => dispatch({ type: "INPUT_BLURRED", config })

  return (
    <div>
      <BigCurrencyInput
        {...{ amount, onChange, onBlur }}
        errors={errorMessages}
        ref={focusRef}
      />
    </div>
  )
}

type ReadOnlyTotalDesignationAmountProps = {
  designations: Designation[]
  errorMessages: ValidationErrorMessage[]
}
function ReadOnlyTotalDesignationAmount(
  props: ReadOnlyTotalDesignationAmountProps,
) {
  const { designations, errorMessages } = props
  const amount = designationTotal(designations).toString()

  return (
    <>
      <BigCurrencyInput
        {...{ amount }}
        readOnly={true}
        errors={errorMessages}
      />
    </>
  )
}
